<template>
	<router-view ref="child" />
</template>
<script>
export default {
	name: 'App',
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue